// --------------------------------------- Project List

export const ProjectList = [
  {
    img: "/images/gunn-inger.png",
    title: "Gunn Inger",
    description:
      "Dette var mitt aller første prosjekt, hvor jeg laget en portefølje. Jeg laget denne i noe som heter bootstrap stuido",
    tech_stack: "Html, Css, Javascript, Bootstrap",
    demo_url: "https://gunninger.bss.design/",
  },
  {
    img: "/images/prinsen-cafe.png",
    title: "Prinsen Cafe",
    description:
      "Dette var et registrerings system hvor kundene til Prinsen Cafe kunne registrere seg under korona pandemien.",
    tech_stack: "Nextjs",
    github_url: "https://github.com/Pettersen3008/prinsenCafe",
    demo_url: "https://prinsen-cafe.vercel.app/",
  },
  {
    img: "/images/ditt-russekort.png",
    title: "Dittrussekort",
    description:
      "Ulrik Hesmyr og jeg lagde en nettside hvor du kunne lage ditt eget russekort. Planen bak dette var at russekort skulle bli digitale og at man kunne dele russekort med qr-kode. ",
    tech_stack: "Html, css, Javascript",
    github_url: "https://github.com/ulrikHesmyr/Dittrussekort.no",
  },
  {
    img: "/images/jobplan.png",
    title: "Jobplan",
    description:
      "Jobplan er en app hvor du skal kunne se når du jobber og føre timer. Dette prosjektet blir laget til Norsjø Golfpark.",
    tech_stack: "Nextjs, Tailwindcss, Typescript",
    github_url: "https://github.com/Pettersen3008/jobplan",
  },
  {
    img: "/images/jobplan.png",
    title: "Jobplan_api",
    description:
      "Jobplan_api er api-et til jobplan appen. Dette prosjektet er et av mine første ferdige prosjekter for backend.",
    tech_stack: "Nodejs, Express, MongoDB, Typescript",
    github_url: "https://github.com/Pettersen3008/jobplan_api",
  },
  {
    img: "/images/password-generator.png",
    title: "Passord Generator",
    description:
      "Passord generator er en nettside som lager et tilfeldig passord til brukeren.",
    tech_stack: "Html ,Css, Javascript",
    github_url: "https://github.com/Pettersen3008/password-generator",
  },
  {
    img: "/images/covid.png",
    title: "Korona Pandemien modell",
    description:
      "Dette var en oppgave jeg gjorde på skolen under vg2. Programmet lager en modell for hvordan korona pandemien utvikler seg",
    tech_stack: "Python, Tkinter, Matplotlib",
    github_url: "https://github.com/Pettersen3008/korona",
  },
  {
    img: "/images/flere.png",
    title: "Flere prosjekter fra vg2 på github",
    description:
      "Her har jeg et repository med flere prosjekter jeg lagde på skolen under vg2.",
    tech_stack: "Python",
    github_url: "https://github.com/Pettersen3008/Progmod",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/110px-Python-logo-notext.svg.png?20100317150552",
    name: "Python",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/590px-Node.js_logo.svg.png?20170401104355",
    name: "NodeJS",
  },
  {
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Nextjs-logo.svg/207px-Nextjs-logo.svg.png?20190307203525",
    name: "Nextjs",
  },
  {
    img: "https://avatars.githubusercontent.com/u/5429470?s=200&v=4",
    name: "Docker",
  },
];
